<template>
  <section>
    <PageTitle>
      <span v-html="$store.state.app.pageName" />
    </PageTitle>
    <PageContent>
      <Container>
        <ul class="bridal-item-group-list">
          <li
            class="bridal-item-group"
            :class="{
              'progress-target': group.progress_target_flag, 
              'complete': subgroupCountNotAdded(group) === 0
            }"
            v-for="group in groupList"
            :key="group.bridal_item_group_id"
          >
            <router-link
              class="birdal-item-group-link"
              :to="$wcRouter.path({
                name: 'bridal-item.show',
                params: { groupId: group.bridal_item_group_id }
              })"
            >
              <figure>
                <div class="bridal-item-group-image-box">
                  <img v-if="group.image_path"
                    class="bridal-item-group-image"
                    :src="group.image_path | appendDomain"
                    :alt="group.bridal_item_group_name"
                  />
                </div>
                <figcaption>
                  <p
                    class="bridal-item-group-name"
                    v-html="group.bridal_item_group_name"
                  ></p>
                </figcaption>
                <ProgressBar
                  :onCount="subgroupCountAdded(group)"
                  :offCount="subgroupCountNotAdded(group)"
                />
              </figure>
            </router-link>
          </li>
        </ul>
      </Container>
    </PageContent>
  </section>
</template>

<script>
import { renderError } from '@/utils/error'
import ProgressBar from '@/components/ProgressBar.vue'
import { SCHEME, getDomain } from '@/api/theme'
import bridalItemApi from '@/api/bridal-item'

const storagePath = SCHEME + getDomain()

export default {
  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'bridal-item' }
    }
  },
  components: {
    ProgressBar,
  },
  data() {
    return {
      groupList: []
    }
  },
  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
  },
  methods: {
    async fetchGroup() {
      try {
        this.groupList = await bridalItemApi.getGroup(this.businessId)
      } catch (err) {
        renderError(err)
      }
    },
    subgroupCountAdded(group) {
      return group.bridal_item_subgroup_added_count
    },
    subgroupCountNotAdded(group) {
      return (group.bridal_item_subgroup_all_count - group.bridal_item_subgroup_added_count)
    },
  },
  filters: {
    appendDomain(val) {
      return storagePath + val
    }
  },
  created() {
    this.$withLoading(this.fetchGroup)
  }
}
</script>